import {
  toPythonStyle,
  toJsStyle,
} from '@xhs/data-transform'

import { isFormData } from './util'

function needParse(arg) {
  return typeof arg === 'object' && !isFormData(arg)
}

export function transformRequestConfig(config) {
  const transformOpts = config.transform

  if (transformOpts) {
    if (needParse(config.data)) {
      config.data = toPythonStyle(config.data, transformOpts)
    }

    if (needParse(config.params)) {
      config.params = toPythonStyle(config.params, transformOpts)
    }
  }

  return config
}

export function transformResponseData(resData, config) {
  const transformOpts = config.transform

  if (config.transform) {
    return toJsStyle(resData, transformOpts)
  }

  return resData
}
